import { HStack, Pressable, useTheme } from 'native-base';
import { CalendarDays } from 'lucide-react';

import { Text } from '@pimm/base';
import { CleaningScheduleTypeEnum } from '@pimm/services/lib/sms-workforce';
import { getScheduleColor } from '../utils';

type MonthTogglePillsProps = {
  labels: (string | null)[];
  activeMonth: number;
  showCalendarIcon?: boolean;
  onPress: (index: number) => void;
};

export const MonthTogglePills = ({ labels, activeMonth, showCalendarIcon = false, onPress }: MonthTogglePillsProps) => {
  const color = getScheduleColor(CleaningScheduleTypeEnum.Monthly);
  const { colors } = useTheme();

  return (
    <>
      {labels.map((label, i) => {
        const isActive = activeMonth === i;
        return (
          <Pressable
            key={i}
            onPress={() => onPress(i)}
            px={3}
            py={1}
            rounded="md"
            bg={isActive ? 'white' : 'transparent'}
            shadow={isActive ? 1 : 'none'}
          >
            <HStack alignItems="center" space={1.5}>
              {showCalendarIcon && <CalendarDays size={14} color={isActive ? colors[color][700] : colors.gray[500]} />}
              <Text size="md" fontWeight={isActive ? 700 : 500} color={isActive ? `${color}.700` : 'gray.600'}>
                {label}
              </Text>
            </HStack>
          </Pressable>
        );
      })}
    </>
  );
};

export default MonthTogglePills;
